import type { ReactNode } from "react";

import { styles } from "@repo/helpers";

import style from "./style.module.scss";

interface ToggleButtonGroupProps {
	children: ReactNode;
	className?: string;
}

export function ToggleButtonGroup({ children, className }: ToggleButtonGroupProps) {
	return <div className={styles(style.toggleButtonGroup, className)}>{children}</div>;
}

interface ToggleButtonProps {
	id: string;
	value: any;
	variant: string & keyof typeof style;
	className?: string;
	disabled?: boolean;
	active: boolean;
	onClick: (value: any) => void;
	children: ReactNode;
}

export function ToggleButton({
	id,
	value,
	variant,
	className,
	disabled,
	active,
	onClick,
	children,
}: ToggleButtonProps) {
	return (
		<button
			id={id}
			type="button"
			className={styles(
				style.toggleButton,
				style[variant],
				active && style.active,
				disabled && style.disabled,
				className,
			)}
			disabled={disabled}
			onClick={() => !disabled && onClick(value)}
		>
			{children}
		</button>
	);
}
